import { createGlobalStyle } from "styled-components";

import MuseoEOT from "../assets/fonts/Museo-300.eot";
import MuseoWOFF2 from "../assets/fonts/Museo-300.woff2";
import MuseoWOFF from "../assets/fonts/Museo-300.woff";
import MuseoTTF from "../assets/fonts/Museo-300.ttf";

import MuseoSlabEOT from "../assets/fonts/MuseoSlab-500.eot";
import MuseoSlabWOFF2 from "../assets/fonts/MuseoSlab-500.woff2";
import MuseoSlabWOFF from "../assets/fonts/MuseoSlab-500.woff";
// import MuseoSlabTTF from "../assets/fonts/MuseoSlab-500.ttf";

import CustomTheme from "./themes/smk-theme";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Museo';
    src: url(${MuseoEOT});
    src: url(${MuseoEOT}?#iefix) format('embedded-opentype'),
      url(${MuseoWOFF2}) format('woff2'),
      url(${MuseoWOFF}) format('woff'),
      url(${MuseoTTF}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Museo';
    src: url(${MuseoEOT});
    src: url(${MuseoEOT}?#iefix) format('embedded-opentype'),
      url(${MuseoWOFF2}) format('woff2'),
      url(${MuseoWOFF}) format('woff'),
      url(${MuseoTTF}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Museo';
    src: url(${MuseoEOT});
    src: url(${MuseoEOT}?#iefix) format('embedded-opentype'),
      url(${MuseoWOFF2}) format('woff2'),
      url(${MuseoWOFF}) format('woff'),
      url(${MuseoTTF}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }


  @font-face {
    font-family: 'Museo';
    src: url(${MuseoSlabEOT});
    src: url(${MuseoSlabEOT}?#iefix) format('embedded-opentype'),
      url(${MuseoSlabWOFF2}) format('woff2'),
      url(${MuseoSlabWOFF}) format('woff');
    font-weight: 500;
    font-style: bold;
  }

  body{
    font-family: 'Museo', sans-serif;
    font-style:normal;
    font-weight: 300;
  }

  .form-control:focus{
    outline: nonet !important;
    border-style: inherit !important;
    box-shadow: none !important;
  }
  .btn:focus, button:focus{
    box-shadow: none !important;
    outline: none !important;
  }

  a, a:active, a:hover, a:focus, a:visited, a:hover{
    text-decoration: none;
    outline: 0;
    color: unset;
    font-weight: 300;
    font-style: normal;
  }

  h1, h2, h3, h4, h5, h6{
    font-weight: 500;
  }

  button{
        font-weight: 300;
    font-style: normal;
  }
  
  p{
    font-weight:300 !important;
  }

  :focus { outline: none; }

  .no-textshadow select {
    color: #81334E;
  }

  select:focus{
    outline:none; 
  }

  select:-moz-focusring {
    outline:none !important; 
    border-style:none !important;
    color: transparent !important;
    text-shadow: 0 0 0 #81334E;
  }

  select::-ms-expand {
    display: none;
  }

`;

export const THEME = CustomTheme;
